export default {
  baseStyle: {
    my: 0,
    fontWeight: 700,
    color: 'fg',
  },
  sizes: {
    // H1
    '3xl': {
      fontSize: '48px',
      lineHeight: '54px',
    },

    // H2
    '2xl': {
      fontSize: '32px',
      lineHeight: '36px',
    },

    // H3
    xl: {
      fontSize: '24px',
      lineHeight: '28px',
    },

    // H4
    lg: {
      fontSize: '20px',
      lineHeight: '24px',
      color: 'fg',
    },

    md: {
      fontSize: '16px',
      lineHeight: '24px',
      color: 'fg',
    },
  },
  defaultProps: {
    size: '3xl',
  },
}
